// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sp-16-banner[data-v-eddb063c]{background-color:#f0f9fe;padding:1rem;border:1px solid red;border-radius:1rem;margin-bottom:2rem;font-size:1rem}.v-alert[data-v-eddb063c]{border-radius:1rem!important}", ""]);
// Exports
module.exports = exports;
